export const initializeSearchForm = (parentHeader) => {
    const searchForm = parentHeader.querySelector('.js-header-search-form');
    const searchFormInput = parentHeader.querySelector('.js-header-search-input');
    const searchFormSubmitButton = parentHeader.querySelector('.js-header-search-submit');

    if (!searchForm || !searchFormInput || !searchFormSubmitButton) {
        return;
    }

    const searchFormSubmit = () => {
        const searchQuery = searchFormInput.value;

        if (searchQuery && searchQuery != '') {
            window.location = '/search?q=' + searchQuery;
        }
    }

    searchFormSubmitButton.addEventListener('click', (e) => {
        e.preventDefault();
        searchFormSubmit();
    });

    searchForm.addEventListener('submit', (e) => {
        e.preventDefault();
        searchFormSubmit();
    });
}